import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Stepper from "../../components/Stepper";
import { useNotification } from "../../contexts";
import Layout from "../../components/Layout";
import FormFooter from "../../components/FormFooter";
import { ROUTES } from "../../constants";
import { UNIT_LEASE_INITIAL_VALUES } from "../../constants/initialValues";
import { UNIT_LEASE_SETTINGS_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import {
  getPropertyUnitLeaseSettings,
  updatePropertyUnitLeaseSettings,
} from "../../services/units";
import FormHeader from "../../components/FormHeader";
import FormUnitLease from "../../components/FormUnitLease";

function Unit(props) {
  const history = useHistory();
  const { id, unitid } = props.match.params;
  const { dispatch } = useNotification();
  const [initialValues, setInitialValues] = useState(UNIT_LEASE_INITIAL_VALUES);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (unitid) {
      setIsLoading(true);
      getPropertyUnitLeaseSettings(id, unitid).then((data) => {
        setInitialValues({
          ...data,
        });
        setIsLoading(false);
      });
    }
  }, [unitid]);

  const onSubmit = (values) => {
    setIsLoading(true);
    updatePropertyUnitLeaseSettings(id, unitid, values).then(() => {
      dispatch({
        type: "add",
        notifications: [{ title: "Property created with success" }],
      });
      history.push(ROUTES.PRIVATE_PROPERTIES);
    });
  };

  return (
    <Layout isLoading={isLoading}>
      <Stepper id={id} unitid={unitid} currentStepIndex={3} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box sx={{ gridArea: "main" }}>
              <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
                <FormHeader
                  title="Listing Lease Settings"
                  description="Complete the form below to create the lease setting for this unit"
                />
                <Grid container spacing={1}>
                  <FormUnitLease />
                </Grid>
              </Paper>
              <FormFooter onCancel={() => history.push(`/property/${id}`)} />
            </Box>
          </form>
        )}
      </Formik>
    </Layout>
  );
}

export default Unit;
